<template>
  <div class="legoHome">
    <div class="courseView" v-for="item in categorys" :key="item.pk">
        <div class="header">
          <div class="left">
            <img class="icon" :src="images.icon" />
            <span class="text">{{item.name}}</span>
          </div>
          <div class="footer" @click="goVideosPage(item.pk)">
            <span class="text">更多》</span>
          </div>
        </div>
        <div class="items">
          <div class="item" v-for="videoItem in item.top_3_videos" :key="videoItem.pk?videoItem.pk:videoItem.id">
            <VideoCourseItem :dic="videoItem" tag="category"/>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import {
  IMG_BANNER,
  IMG_SCRATCH_ICON
} from "@/assets";
import { Utils } from "@/utils";

import VideoCourseItem from './VideoCourseItem.vue';


import { types as VideoCourseTypes } from '@/store/modules/video_course.js'
import { types as WorkTypes } from '@/store/modules/work.js'
import { types as CompanyTypes} from '@/store/modules/company.js'
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";


export default {
  name: "ScratchHome",
  components: {
    VideoCourseItem,
  },
  data () {
    return {
      images: {
        banner: IMG_BANNER,
        icon: IMG_SCRATCH_ICON
      },
     
    };
  },
  computed: {
    ...mapState({
      categorys: state => state.video_course.categorys.data,
      
      top_data: state => state.work.user_top_data.data,
      move_data: state => state.work.move_data.data,
      current_ad: state => state.video_course.current_ad
    })
  },

  methods: {
    ...mapActions({
      fetchCategorys: VideoCourseTypes.FETCH_LEGO_VIDEOS_CATEGORYS,
      fetchAdData: VideoCourseTypes.FETCH_AD_LIST_DATA,
      fetchWorksData: WorkTypes.FETCH_LIST_MY_WORKS,
      fetchLikeWorkEvent: WorkTypes.FETCH_LIKE_EVENT,
      fetchDeleteWorkEvent: WorkTypes.FETCH_DELETE_WORK,
      fetchCreateProduct:CompanyTypes.FETCH_PRODUCT_CREATE,
      fetchCategoryVideoCourseData: VideoCourseTypes.FETCH_LIST_DATA_VIDEOS,
    }),
    ...Utils,

    // 去到广告页
    goBannerDetail(){
      window.open(
        `${this.current_ad.link}`,
        "_blank"
      );
    },
    // 查看更多页
    goMorePage(tag){
      if(['user_top', 'move'].includes(tag)){
        // 作品更多页
        this.$router.push(`/works?tag=${tag}`);
      }
    },
    // 视频列表页
    goVideosPage(pk){
      this.$router.push(`/videoCourse/${pk}/`);
    },

    // --------------workItem 组件回调事件
    //点赞作品
    likeWorkEvent(item, dataType) {
      this.fetchLikeWorkEvent({pk:item.pk, data_type: dataType});
    },
    //作品详情页
    jumpToWorkDetail(item) {
      let host = location.host;
      if (location.host.indexOf("develop.cxy61.com") > -1) {
        host = "app.bcjiaoyu.com";
      }
      window.open(
        `https://${host}/html/works/works_detail.html?pk=${item.pk}`,
        "_blank"
      );
    },
    // 将作品放到公司产品中
    sendToCompanyEvent(item){
      this.fetchCreateProduct({showwork_id:item.pk})
    },
    // 删除作品
    deleteWork(item, dataType){
      this.fetchDeleteWorkEvent({pk:item.pk, data_type: dataType});
    }
  },
  created () {
  },
  destroyed () {
  },
  mounted () {
    this.fetchAdData({page:1, page_size:1});
    this.fetchCategorys()
    this.fetchWorksData({page:1, page_size:4, owner:"88820190449", data_type:"move", work_type:"scratch3"});
    this.fetchWorksData({page:1, page_size:8, top:true, data_type:"user_top", work_type:"scratch3"})
    // this.fetchWorksData({page:1, data_type:"move", work_type:"scratch3"});
    // this.fetchWorksData({page:1, data_type:"user_top", work_type:"scratch3"})
  }
};
</script>

<style lang="less" scoped>
.legoHome{
  .ad{
    cursor: pointer; 
    margin: 10px; 
    border-radius: 5px;
    overflow: hidden;
    display: flex;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .courseView{
    background-color: #F8F8F8;
    border-radius: 4px;
    margin: 10px;
    padding: 10px;
    .header{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .left{
        display: flex;
        flex-direction: row;
        align-items: center;
        .icon{
          width: 30px;
          // height: 25px;
        }
        .text{
          color: #333333;
          margin-left: 10px;
          font-size: 16px;
          font-weight: bold;
        }
      }
      
    }
    .items{
      display: flex;
      flex-direction: row;
      margin: 10px 0;
      margin-left: -10px;
      margin-bottom: 0;
      min-height: 120px;
      flex-wrap: wrap;
      .item{
        width: calc(100% / 3 - 12px);
        margin-left: 10px;
        margin-bottom: 10px;
        border: solid 1px #EBEBEB;
        cursor: pointer;
        background-color: #ffffff;
        border-radius: 4px;
        overflow: hidden;
        &.four_item{
          width: calc(100% / 4 - 12px);
        }
      }
    }
    .footer{
      display: flex;
      flex-direction: row;
      justify-content:flex-end;
      .text{
        color: #6B45E1;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
}
</style>
